import script from "./Room.vue?vue&type=script&setup=true&lang=js"
export * from "./Room.vue?vue&type=script&setup=true&lang=js"

import "./Room.vue?vue&type=style&index=0&id=050651f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-050651f9"]])

export default __exports__